const RETURN_PATH_KEY = "mira:return-path";

function isSafeReturnPath(path: string | null): path is string {
  return Boolean(path?.startsWith("/") && !path.startsWith("//") && path !== "/login");
}

export function rememberReturnPath(path: string) {
  if (!isSafeReturnPath(path)) return;
  try {
    window.sessionStorage.setItem(RETURN_PATH_KEY, path);
  } catch {
    // A navegação continua funcionando quando o armazenamento está indisponível.
  }
}

export function takeReturnPath() {
  try {
    const path = window.sessionStorage.getItem(RETURN_PATH_KEY);
    window.sessionStorage.removeItem(RETURN_PATH_KEY);
    return isSafeReturnPath(path) ? path : "/";
  } catch {
    return "/";
  }
}
